import type { Guide } from '../types';

/**
 * S-26.10-11 — pulpit Administracji: ostatnie zapisy do TMS i sprzedane przez Trade (prace 26.10.2026,
 * pakiet P4b; scenariusz e2e 38). Dane pokazowe: zlecenie sprzedane przez Trade DEMO/2026/10/RZ3
 * z frachtem przewoźnika i zapisy do TMS z danych pokazowych przyjęcia zleceń.
 */
export const guide: Guide = {
  flagKey: 'adminDashboardSections',
  title: 'Pulpit Administracji: zapisy do TMS i sprzedane przez Trade',
  whatItDoes:
    'Pod kafelkami Administracji na pulpicie przyjęcia zleceń są dwie sekcje. „Ostatnie zapisy do TMS” — ostatnie pliki zleceń: numer w TMS, gdy import go przyniósł, stan zapisu, czy trzeba było ponawiać i ostatni błąd. „Sprzedane przez Trade” — zlecenia sprzedane przez Trade z przewoźnikiem, ceną klienta, kosztem przewoźnika i marżą z pasmem. Bez kosztu przewoźnika marża jest pusta z powodem, nie zero.',
  audience: ['Administracja', 'administrator'],
  presentationItems: ['S-26.10-11'],
  steps: [
    {
      route: '/intake-dashboard',
      target: 'adm-dashboard-tms-writes',
      title: 'Ostatnie zapisy do TMS',
      description:
        'Dziesięć ostatnich zleceń z plikiem dla TMS: nasz numer, numer w TMS (przychodzi z importu), stan zapisu i liczba prób dostarczenia. „Po ponowieniu” oznacza, że któraś próba się nie udała; przy niezapisanym widać ostatni błąd.',
      action: 'Otwórz „Pulpit przyjęcia zleceń” i przejrzyj sekcję pod kafelkami Administracji.',
      recorder: { account: 'adm' },
    },
    {
      route: '/intake-dashboard',
      target: 'adm-dashboard-sold',
      title: 'Sprzedane przez Trade — marża',
      description:
        'Zlecenia sprzedane przez Trade w ostatnich 30 dniach: przewoźnik i numer pojazdu, cena klienta, koszt przewoźnika (fracht z TMS, a bez niego zaakceptowana oferta wpisana przez Trade) i marża z pasmem — ta sama reguła co przy ofertach przewoźników, kurs NBP z dnia załadunku.',
      action: 'Najedź na pasmo marży, żeby zobaczyć regułę.',
      recorder: { account: 'adm' },
    },
  ],
};
